import classNames from 'classnames';

import { ImageEmbedded, ImageEmbeddedProps } from '../../../image/image-embedded';
import { SimpleText, SimpleTextProps } from '../../../simple-text/simple-text.component';

export interface QuoteCarouselItemQuoterProps {
  logo?: ImageEmbeddedProps;
  person?: SimpleTextProps;
  titleOfPerson?: SimpleTextProps;
  isOnImageCarousel?: boolean;
}

export const QuoteCarouselItemQuoter = ({
  logo,
  person,
  titleOfPerson,
  isOnImageCarousel,
}: QuoteCarouselItemQuoterProps) => {
  return (
    <div
      data-testid="snowflake-quote-carousel-item-quoter"
      className={classNames('snowflake-quote-carousel-item-quoter', {
        'snowflake-quote-carousel-item-quoter-on-image': isOnImageCarousel,
      })}
    >
      {logo && (
        <div
          data-testid="snowflake-quote-carousel-item-logo"
          className={classNames('snowflake-quote-carousel-item-logo snowflake-logo', {
            'snowflake-quote-carousel-item-logo-on-image': isOnImageCarousel,
          })}
        >
          <ImageEmbedded baseCssClass="cmp-image" {...logo} />
        </div>
      )}
      <div className="snowflake-quote-carousel-item-divider" />
      {(person || titleOfPerson) && (
        <div
          data-testid="snowflake-quote-carousel-item-person-wrapper"
          className="snowflake-quote-carousel-item-person-wrapper"
        >
          {person && (
            <div data-testid="snowflake-quote-carousel-item-person" className="snowflake-quote-carousel-item-person">
              <SimpleText variant="body2" {...person} />
            </div>
          )}

          {titleOfPerson && (
            <div
              data-testid="snowflake-quote-carousel-item-title-of-person"
              className="snowflake-quote-carousel-item-title-of-person"
            >
              <SimpleText variant="body2" {...titleOfPerson} />
            </div>
          )}
        </div>
      )}
    </div>
  );
};
